<template>
  <b-modal
    :active="true"
    aria-role="dialog"
    aria-modal
    trap-focus
    scroll="keep"
    full-screen
    class="dij-modal-dynamic-width"
  >
    <div class="modal-card">
      <header class="modal-card-head">Instrument Details</header>

      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-three-quarters">
            <div class="columns">
              <div class="column">
                <b-field>
                  <template slot="label"> Instrument ID </template>
                  <b-input
                    disabled
                    v-model="instrumentId"
                    placeholder="Enter Instrument ID"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Name </template>
                  <b-input
                    disabled
                    v-model="instrumentName"
                    placeholder="Enter Instrument Name"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Type </template>
                  <b-input
                    disabled
                    v-model="typeName"
                    placeholder="Enter Instrument Type"
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-field>
                  <template slot="label"> Last Calibrated Date </template>
                  <b-input
                    disabled
                    v-model="lastCalibrationDate"
                    placeholder="Enter Last Calibrated Date"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Calibration Schedule </template>
                  <b-input
                    disabled
                    v-model="calibrationSchedule"
                    placeholder="Enter Calibration Schedule"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Calibration Due Date </template>
                  <b-input
                    disabled
                    v-model="calibrationDueDate"
                    placeholder="Enter Calibration Due Date"
                  ></b-input>
                </b-field>
              </div>

              <div class="column">
                <b-field>
                  <template slot="label"> Status </template>
                  <b-input
                    disabled
                    v-model="instrumentStatus"
                    placeholder="Enter Instrument Status"
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-field>
                  <template slot="label"> Service Center </template>
                  <b-input
                    disabled
                    v-model="siteName"
                    placeholder="Enter Site Name"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Storage Location </template>
                  <b-input
                    disabled
                    v-model="instrumentStorageLocation"
                    placeholder="Enter Storage Location"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <template slot="label"> Responsible </template>
                  <b-input
                    disabled
                    v-model="instrumentIdResponsible"
                    placeholder="Enter Responsible"
                  ></b-input>
                </b-field>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="columns" style="margin-bottom: 30px">
              <div style="display: flex; gap: 5px" @click.stop>
                <b-button
                  v-on:click="showQRCode"
                  icon-left="qrcode"
                  :disabled="isLoading"
                >
                  {{ $t('view_qr_code') }}
                </b-button>
                <b-button
                  v-on:click="openDocumentsModal"
                  icon-left="file-document-arrow-right"
                  :disabled="isLoading"
                >
                  Documents
                </b-button>

                <b-button
                  icon-left="pencil"
                  @click="onEdit"
                  :disabled="isLoading"
                />
                <b-button
                  type="is-danger"
                  icon-right="delete"
                  @click="onDelete(instrumentation)"
                  :disabled="isLoading"
                />
              </div>
            </div>
            <div class="columns">
              <RichTextEditor
                v-model="instrumentation.notes"
                @onBlur="updateNotes"
                :label="'Notes'"
              />
            </div>
          </div>
        </div>
        <QRCodeViewer
          v-if="isQRCodeModalVisible"
          @onClose="() => (isQRCodeModalVisible = false)"
          :qrString="instrumentId"
          :disableDownloadTraveler="true"
        />
        <div class="export-container">
          <b-field>
            <template slot="label"> Instrument History </template>
          </b-field>
          <b-button
            type="is-primary"
            icon-left="microsoft-excel"
            label="Export Data"
            @click="exportToExcel"
          />
        </div>
        <b-table
          :data="instrumentHistory"
          :narrowed="true"
          :loading="isLoading"
          :paginated="instrumentHistory.length > 20 ? true : false"
          :per-page="20"
        >
          <template slot-scope="props">
            <b-table-column field="jobNumber" label="Job Number" sortable>
              {{ props.row.jobNumber }}
            </b-table-column>

            <b-table-column field="taskName" label="Task Name" sortable>
              {{ props.row.taskName }}
            </b-table-column>

            <b-table-column field="usedBy" label="Used By" sortable centered>
              {{ props.row.usedBy }}
            </b-table-column>

            <b-table-column field="usedOn" label="Used On" sortable centered>
              {{ new Date(props.row.usedOn).toLocaleDateString() }}
            </b-table-column>

            <b-table-column
              field="calibrationDueDateAtlogging"
              label="Calibration Date (at the time of logging)"
              sortable
              centered
            >
              {{
                new Date(
                  props.row.calibrationDueDateAtlogging
                ).toLocaleDateString()
              }}
            </b-table-column>
          </template>
          <template #empty>
            <div class="has-text-centered">No records</div>
          </template>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">
          {{ $t('close') }}
        </b-button>
      </footer>
    </div>
    <AddIntrumentModal
      v-if="isModalOpen"
      @close="closeAddInstrumentation"
      @onUpdate="onUpdate"
      :instrumentation="instrumentation"
    />
    <InstrumentDocumentsModal
      v-if="isDocumentsModalOpen"
      @close="closeDocumentsModal"
      @onUpdate="onUpdate"
      :instrumentation="instrumentation"
    />
  </b-modal>
</template>

<script>
import * as xlsx from 'xlsx';
import RichTextEditor from '../../RichTextEditor';
import QRCodeViewer from '../../layout/QRCodeViewer';
import { GET_INSTRUMENTATION_HISTORY } from '../../../store/instrumentations/getters/getterTypes';
import {
  FETCH_INSTRUMENTATION_HISTORY,
  UPDATE_INSTRUMENTATION,
  DELETE_INSTRUMENTATION,
} from '../../../store/instrumentations/actions/actionTypes';
import { INSTRUMENTATION_PERIODS, INSTRUMENTATION_STATUS } from './constants';
import AddIntrumentModal from './AddIntrumentModal';
import InstrumentDocumentsModal from './InstrumentDocumentsModal';

export default {
  name: 'InstrumentDetailsModal',
  components: {
    RichTextEditor,
    QRCodeViewer,
    AddIntrumentModal,
    InstrumentDocumentsModal,
  },
  props: {
    propInstrumentation: {
      type: Object,
      required: true,
    },
    selectedSite: {
      type: Object,
      required: true,
    },
  },

  computed: {
    instrumentHistory() {
      return this.$store.getters[GET_INSTRUMENTATION_HISTORY];
    },
  },

  data() {
    return {
      instrumentation: this.propInstrumentation,
      isLoading: false,
      instrumentId: '',
      instrumentName: '',
      typeName: '',
      calibrationDueDate: '',
      lastCalibrationDate: '',
      calibrationSchedule: '',
      instrumentStatus: '',
      siteName: '',
      instrumentIdResponsible: '',
      instrumentStorageLocation: '',
      isQRCodeModalVisible: false,
      notes: '',
      isModalOpen: false,
      isDocumentsModalOpen: false,
    };
  },

  async mounted() {
    this.isLoading = true;
    try {
      await this.$store.dispatch(FETCH_INSTRUMENTATION_HISTORY, {
        instrumentationId: this.instrumentation._id,
      });
      this.setInstrumentationDetails();
    } catch (error) {
      console.error('Error fetching instrumentations:', error);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    closeDocumentsModal() {
      this.isDocumentsModalOpen = false;
    },

    openDocumentsModal() {
      this.isDocumentsModalOpen = true;
    },

    onEdit() {
      this.isModalOpen = true;
    },

    onDelete(instrument) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Instrument ',
        message: `Are you sure you want to <b>delete</b> Instrument : ${instrument.instrumentName}, ID: ${instrument.instrumentId}? This action cannot be undone.`,
        confirmText: 'Delete Instrument',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch(DELETE_INSTRUMENTATION, {
            instrumentationId: instrument._id,
          });
          this.close();
        },
      });
    },

    onUpdate(data) {
      this.instrumentation = { ...this.instrumentation, ...data };
      this.setInstrumentationDetails();
      this.$emit('onUpdate', this.instrumentation);
      this.closeAddInstrumentation();
    },

    exportToExcel() {
      const data = this.instrumentHistory.map((instrument) => ({
        'Job Number': instrument.jobNumber,
        'Task Name': instrument.taskName,
        'Used By': instrument.usedBy,
        'Used On': new Date(instrument.usedOn).toLocaleDateString(),
        'Calibration Date (at the time of logging)': new Date(
          instrument.calibrationDueDateAtlogging
        ).toLocaleDateString(),
      }));

      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Instrument History');
      xlsx.writeFile(
        workbook,
        `${this.instrumentation.instrumentId}_${this.instrumentation.instrumentName}_history.xlsx`
      );
    },

    closeAddInstrumentation() {
      this.isModalOpen = false;
    },

    updateNotes() {
      this.$store.dispatch(UPDATE_INSTRUMENTATION, {
        instrumentationData: {
          notes: this.instrumentation.notes,
        },
        instrumentationId: this.instrumentation._id,
        siteId: this.selectedSite._id,
      });
    },

    showQRCode() {
      this.isQRCodeModalVisible = true;
    },
    setInstrumentationDetails() {
      this.instrumentId = this.instrumentation.instrumentId || '';
      this.instrumentName = this.instrumentation.instrumentName || '';
      this.typeName = this.instrumentation.typeName || '';
      this.calibrationDueDate = this.instrumentation.calibrationDueDate
        ? new Date(this.instrumentation.calibrationDueDate).toLocaleDateString()
        : '';
      this.lastCalibrationDate = this.instrumentation.lastCalibrationDate
        ? new Date(
            this.instrumentation.lastCalibrationDate
          ).toLocaleDateString()
        : '';

      this.calibrationSchedule =
        this.instrumentation.calibrationSchedule === 'manual'
          ? 'Manual'
          : INSTRUMENTATION_PERIODS.find(
              (period) =>
                period.value ===
                parseInt(this.instrumentation.calibrationSchedule, 10)
            )?.title;

      this.instrumentStatus = INSTRUMENTATION_STATUS.find(
        (status) => status.value === this.instrumentation.status
      )?.title;

      this.siteName = this.selectedSite.siteName;

      this.instrumentIdResponsible = this.instrumentation.responsible || '';
      this.instrumentStorageLocation =
        this.instrumentation.storageLocation || '';
      this.notes = this.instrumentation.notes || '';
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.export-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
